// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"95":"ddca2a76","265":"1f68d89c","336":"c9e59f2f","460":"9ddf197c"}[chunkId] + ".js";
};